import axios from 'axios';
import connection from './connection';
import { AssetCheckListReq, AssetChecklistResponseModel, CommonResponse } from '@gtpl/shared-models/masters';

export class AssetCheckListServices {
  URL = connection.DEPLOY_URL + '/asset_checklist';


  async createAssetCheckList(hrmsdto: AssetCheckListReq): Promise<AssetChecklistResponseModel> {
    return await axios.post(this.URL + '/createAssetCheckList', hrmsdto)
      .then(res => {
        return res.data
      })
  }

  async updateAssetCheckList(hrmsdto: AssetCheckListReq): Promise<CommonResponse> {
    return await axios.post(this.URL + '/updateAssetCheckList', hrmsdto)
      .then(res => {
        return res.data
      })
  }

  async activateOrDeactivateAssetCheckList(hrmsDto: any): Promise<AssetChecklistResponseModel> {
    //   console.log(State.stateCode);
    return await axios.post(this.URL + '/activateOrDeactivateAssetCheckList', hrmsDto)
      .then(res => {
        return res.data
      })
  }
 

  async getAllAssetCheckList(): Promise<CommonResponse> {

    return await axios.post(this.URL + '/getAllAssetCheckList')
      .then(res => {
        return res.data
      })
  }

  async getActiveAllAssetCheckList(): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getActiveAllAssetCheckList').then((res) => {
      return res.data;
    });
  }

 
}